<template>

  <div style="position: relative;"
       :style="{ pointerEvents: loading ? 'none' : 'all' }">

    <div>

      <div v-if="loading" class="overlay">
        <div class="absolute-center text-xs-center">
          <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
          <h4>Loading Data</h4>
        </div>
      </div>

    </div>

    <v-tabs
      fixed-tabs
      light
      class=""
    >

      <v-tabs-slider color="primary"/>

      <v-tab
        :to="`/variable/${$route.params.id}`"
        exact
        color="info"
        :ripple="false"
      >
        <v-icon class="pr-2">show_chart</v-icon>
        Chart
      </v-tab>

      <v-tab
        :to="`/variable/${$route.params.id}/table`"
        exact
        :ripple="false"
      >
        <v-icon class="pr-2">grid_on</v-icon>
        Table
      </v-tab>

    </v-tabs>

    <!--<v-container fluid class="text-xs-right ma-0 pa-0">-->
      <!--<v-btn small outline @click="refreshData()" :disabled="refresh">-->
        <!--<v-icon class="pr-2" small>refresh</v-icon>-->
        <!--Refresh-->
      <!--</v-btn>-->
    <!--</v-container>-->

    <router-view></router-view>

  </div>

</template>

<script>
  import favoriteStations from '@/models/favorite-stations';
  import TimeSeries from '@/models/TimeSeries';
  import DateRange from '@/models/DateRange';

  export default {

    name: 'SensorVariableIndex',

    data() {
      return {
        loading: false,
        refresh: false,
      };
    },

    mounted() {
      console.warn('mounted: SensorVariableIndex');
      this.loadData();
    },

    updated() {
      console.warn('updated: SensorVariableIndex');
    },

    watch: {

      // eslint-disable-next-line
      '$store.state.universal.appOptions': {
        deep: true,
        handler() {
          this.refresh = true;
          this.loadData();
        },
      },

      $route: {
        deep: true,
        async handler() {
          console.log('$route handler watch');
          this.refresh = true;
          this.loadData();
        },
      },

    },

    methods: {

      refreshData() {
        this.refresh = true;
        this.loadData();
      },

      async loadData() {
        const dateRange = new DateRange(this.dateRange.start, this.dateRange.end);
        this.loading = true;
        if (this.refresh
          || !this.$store.state.sensorVariable.current
          || !dateRange.interval.equals(this.$store.state.sensorVariable.current.range.interval)) {
          console.group('Loading Sensor Variable data for:', this.$route.params.id);
          console.log('Refresh:', this.refresh);
          console.log('Building timeseries');
          const timeSeries = new TimeSeries({
            range: dateRange,
            vars: this.$route.params.id,
            stids: favoriteStations.map(fav => fav.stid).join(','),
            // stids: 'MAMC1',
          });

          console.log('Fetching data');
          const timeSeriesData = await timeSeries.loadData();

          if (timeSeriesData.timeseries.SUMMARY.NUMBER_OF_OBJECTS > 0) {
            console.log('Creating Sensor Variable container.');

            this.$store.dispatch('initializeSensorVariable', {
              data: timeSeriesData,
              range: new DateRange(this.dateRange.start, this.dateRange.end),
              variable: this.$route.params.id,
            });
          }

          this.refresh = false;
        }
        this.loading = false;
      },

    },

    computed: {

      dateRange() {
        return this.$store.state.universal.dateRange;
      },

    },

  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SensorVariable/Index.vue